import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Camera, X, ArrowRight } from "lucide-react";
import NicheComUsageCard from "./NicheComUsageCard";

export default function NicheComDrawer({ data }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  if (!data?.enabled) return null;

  return (
    <>
      {/* Edge tab handle */}
      <div className="fixed right-0 top-1/2 z-40" style={{ transform: "translateY(-50%)" }}>
        <button
          onClick={() => setOpen(true)}
          data-testid="nichecom-drawer-tab"
          aria-label="Open NicheCom usage"
          className="flex flex-col items-center gap-2 rounded-l-2xl px-2.5 py-4 text-white transition-transform hover:-translate-x-0.5 focus-ring"
          style={{ background: "var(--grad-green)", boxShadow: "0 12px 30px -8px rgba(95,130,19,.6)" }}
        >
          <Camera size={16} strokeWidth={2} />
          <span className="text-[11px] font-bold uppercase tracking-[0.18em]" style={{ writingMode: "vertical-rl" }}>NicheCom</span>
          <span className="rounded-full bg-white/25 px-1.5 py-0.5 text-[11px] font-extrabold tabular-nums">{data.overall}%</span>
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <>
            <motion.div
              initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
              onClick={() => setOpen(false)}
              className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm"
              data-testid="nichecom-drawer-backdrop"
            />
            <motion.aside
              initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }}
              transition={{ type: "tween", duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
              className="fixed right-0 top-0 z-50 h-full w-full max-w-md overflow-y-auto shadow-2xl"
              style={{ background: "#F7F8F6" }}
              data-testid="nichecom-drawer-panel"
            >
              <div className="sticky top-0 z-10 flex items-center justify-between border-b px-6 py-4" style={{ borderColor: "#E7E8E4", background: "rgba(247,248,246,.92)", backdropFilter: "blur(8px)" }}>
                <div className="flex items-center gap-2.5">
                  <span className="grid place-items-center w-9 h-9 rounded-lg" style={{ background: "var(--grad-green-soft)" }}><Camera size={16} strokeWidth={1.75} style={{ color: "#5F8213" }} /></span>
                  <div>
                    <div className="label-caps">NicheCom</div>
                    <div className="text-sm font-bold text-ink">Your content usage</div>
                  </div>
                </div>
                <button onClick={() => setOpen(false)} data-testid="nichecom-drawer-close" className="grid place-items-center w-9 h-9 rounded-lg text-ink-2 hover:bg-black/5 focus-ring"><X size={18} /></button>
              </div>

              <div className="p-6 space-y-5">
                <NicheComUsageCard data={data} />
                <div className="card p-6" data-testid="nichecom-drawer-missed">
                  <span className="label-caps">Unused marketing opportunity</span>
                  <p className="text-lg font-semibold text-ink mt-2 leading-snug">You already have the content — Growth helps you turn it into visibility.</p>
                  <p className="text-sm text-ink-2 mt-2">Several properties have available NicheCom assets that don't appear to have been fully used.</p>
                  <button className="btn-secondary focus-ring mt-4" onClick={() => { setOpen(false); navigate("/app/nichecom"); }} data-testid="nichecom-drawer-missed-cta">See missed properties <ArrowRight size={15} strokeWidth={2} /></button>
                </div>
              </div>
            </motion.aside>
          </>
        )}
      </AnimatePresence>
    </>
  );
}
